import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { ReactComponent as ExportIconSvg } from 'assets/svg/ExportSharableLink.svg';
import { useDownloadCsvLeads } from 'hooks/useDownloadCsvLeads';
import Skeleton from 'react-loading-skeleton';
import { ClipLoader } from 'react-spinners';
import { Fragment } from 'react/jsx-runtime';
import { useLeadsStore } from 'store/leadsStore';
import { Lead } from 'types/Lead';
import { LeadsContent } from './LeadsContent';
import VerticalTabs from './VerticalTabs';

const Component = () => {
    const { currentPage, status } = useLeadsStore();
    const isLoading = useIsFetching({ queryKey: ['leads', currentPage, status] });
    const queryClient = useQueryClient();
    const data = queryClient.getQueryData(['leads', currentPage, status]) as { inquiries: Array<Lead>; total: number };

    const { mutate, isPending } = useDownloadCsvLeads();

    return (
        <div className="flex flex-col gap-10 w-full p-10">
            <div className="flex justify-between ">
                <div>
                    {isLoading ? (
                        <Skeleton className="h-full w-28" />
                    ) : (
                        <span className="font-semibold lg:text-[20px] md:text-[18px]">{data?.total} Leads</span>
                    )}
                </div>

                {isPending ? (
                    <ClipLoader loading={isPending} color="#0000FF" className="mr-10" />
                ) : (
                    <button
                        className="flex gap-3 sm:w-40  md:w-64 lg:w-auto items-center justify-center border-2 border-blue-500 rounded h-min py-2 px-5"
                        onClick={() => mutate()}
                        disabled={data?.inquiries?.length === 0 || Boolean(isLoading)}
                    >
                        <ExportIconSvg />
                        <span>Export</span>
                    </button>
                )}
            </div>
            <LeadsContent />
        </div>
    );
};

const tabs = [
    { name: 'All Leads', component: <Component />, key: '' },
    { name: 'New Leads', component: <Component />, key: 'new' },
    { name: 'Contacted', component: <Component />, key: 'contacted' },
    { name: 'Follow-up', component: <Component />, key: 'follow-up' },
    { name: 'Active', component: <Component />, key: 'active' },
    { name: 'Inactive', component: <Component />, key: 'inactive' },
    { name: 'Qualified', component: <Component />, key: 'qualified' },
    { name: 'Closed', component: <Component />, key: 'closed' },
];
export default function Leads() {
    return (
        <Fragment>
            <div className="h-screen bg-white">
                <VerticalTabs tabs={tabs} />
            </div>
        </Fragment>
    );
}
